export const dataAssessorInfo = {
  type: 'object',
  required: ['Firstname', 'LastName'],
  properties: {
    Firstname: {
      type: 'string',
      minLength: 1,
    },
    MiddleName: {
      type: ['null', 'string'],
    },
    LastName: {
      type: 'string',
      minLength: 1,
    },
    CenterName: {
      type: ['null', 'string'],
    },
    CenterNum: {
      type: ['null', 'string'],
    },
  },
};
